import dayjs from "dayjs";

export const convertMillisecondsToDatetime = (milliseconds, format = "DD/MM/YYYY") => {
  return dayjs(milliseconds).format(format);
};

export const convertMillisecondsToDateTime = (milliseconds, format = "HH:mm DD/MM/YYYY") => {
  return dayjs(milliseconds).format(format);
};
